import { render, staticRenderFns } from "./Dots.vue?vue&type=template&id=75a07b6a"
import script from "./Dots.vue?vue&type=script&lang=ts"
export * from "./Dots.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports